<template>
	<div class="oph-details absolute inset-0 bg-black">
		<div class="svg s-fill" v-if="svg" v-html="svg"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	
	import { mapState } from 'vuex'

	import soundEffectMixin from '@/mixins/soundEffectMixin'

	export default {
		name: 'OPH',
		mixins: [soundEffectMixin],
		data() {
			return {
				locations: [],
				svg: null,
				soundEffects: {
					floor: require('../assets/sounds/oph_floor.mp3'),
				},
			}
		},
		computed: {
			...mapState('Auth', [ 'userInfo' ]),
		},
		async mounted() {
			// Load locations and scenarios data
			if (this.$store.state.Locations.list.length <= 0) {
				await this.$store.dispatch('Locations/getList')
			}
			if (this.$store.state.Scenarios.list.length <= 0) {
				await this.$store.dispatch('Scenarios/getList')
			}

			const locations = this.$store.state.Locations.list.reduce((dict, location) => {
				dict[location.slug] = location

				return dict
			}, {})

			// Create a dictionary of location_id => scenarios_list
			let locationScenarios = this.$store.state.Scenarios.list.reduce((dict, scenario) => {
				for (var j = 0; j < scenario.locations.length; j++) {
					if (!dict[scenario.locations[j].id])
						dict[scenario.locations[j].id] = []

					dict[scenario.locations[j].id].push(scenario)
				}

				return dict
			}, {})

			// Set locations scenarios list (todo improve ?)
			const slugs = Object.keys(locations)
			for (var k = 0; k < slugs.length; k++) {
				const scenarios = locationScenarios[locations[slugs[k]].id]

				if (!scenarios)
					continue

				locations[slugs[k]].scenarios = scenarios

				// Load location availibility if needed
				if (!this.userInfo.experienced) {
					locations[slugs[k]].show = await this.shouldShowFloor(locations, slugs[k])
				} else {
					locations[slugs[k]].show = true
				}
			}

			this.locations = locations

			const url = require('../assets/images/oph.svg')
			
			// Load SVG content
			axios(url).then((response) => {
				this.svg = response.data

				// Add click listener to all overlay elements
				this.$nextTick(() => {
					const children = document.getElementById('faa-overlay').childNodes

					for (var i = 0; i < children.length; i++) {
						children[i].addEventListener('click', this.floorClick)
						
						// Hide some floors if needed
						if (!this.userInfo.experienced) {
							const location = this.locations[children[i].id]
							
							if (location && location.show === false) {
								children[i].style.display = 'none'
							}
						}
					}
				})
			})
		},
		methods: {
			async shouldShowFloor(locations, slug) {
				if (this.userInfo.experienced)
					return true

				const location = locations[slug]

				if (location && location.order == 0)
					return true

				// Get previous location
				const previousLocations = this.$store.state.Locations.list.filter((loc) => {
					return (loc.order == (location.order - 1))
				})

				// Get main scenarios
				const mainScenarios = previousLocations.reduce((list, location) => {
					const mainScenario = locations[location.slug].scenarios.find((scenario) => {
						return (scenario.type.slug == 'scenario')
					})

					if (mainScenario) {
						list.push(mainScenario)
					}


					return list
				}, [])

				// Get scenarios completion state
				const scenarioCompletionState = await this.$store.dispatch('Logs/getByTypeSlug', {
					type_slug: 'scenario_end',
				})

				const completedScenariosById = scenarioCompletionState.reduce((dict, log) => {
					dict[log.data_key] = true

					return dict
				}, {})

				// Check if one of the main scenarios is not completed
				for (var i = mainScenarios.length - 1; i >= 0; i--) {
					if (!completedScenariosById[mainScenarios[i].id]) {
						return false
					}
				}

				return true
			},
			async floorClick(evt) {
				this.playSoundEffect('floor')

				// todo: common logic ?
				const location = this.locations[evt.currentTarget.id]

				if (!location || !location.scenarios || location.scenarios.length <= 0)
					return

				// Check for introduction scenario of this locations
				const introduction = location.scenarios.find((scenario) => {
					return (scenario.type.slug == 'intro')
				})

				if (introduction && introduction.id) {
					this.$router.push({
						name: 'Scenario',
						params: {
							id: introduction.id
						}
					})
					return
				}

				// Launch main scenario of the selected location
				const scenario = location.scenarios.find((scenario) => {
					return (scenario.type.slug == 'scenario')
				})

				if (scenario && scenario.id) {
					this.$router.push({
						name: 'Scenario',
						params: {
							id: scenario.id
						}
					})
				}
			},
		}
	}

</script>

<style lang="scss">

.oph-details .svg svg {
	width: 100%;
	height: 100%;
	max-width: 100%;
	max-height: 100%;
	
	& > g {
		pointer-events: none;
	}

	#faa-overlay {
		pointer-events: none;
		transform: translateZ(0);

		& > g {
			pointer-events: all;
			transform: translateZ(0);
			cursor: pointer;
			opacity: 0;
			transition: opacity 0.3s;

			&:hover {
				opacity: 1;
			}
		}
	}
}
</style>